import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from "../../utils/authFetch";
import PageLoader from '../../components/PageLoader';

const GerarUsuarioResp = () => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [userRoleId, setUserRoleId] = useState(3);
    const { showNotification } = useNotification();
    const [responsavel, setResponsavel] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();    
    const { id } = useParams();

    useEffect(() => {
        const fetchResponsavel = async () => {
            try {
                const response = await authFetch(`guardian/${id}`, {
                    method: "GET",                    
                });
                if (!response.ok) {
                    throw new Error("Erro ao buscar terapeuta");
                }
                const data = await response.json();
                setResponsavel(data);  // Guarda o objeto inteiro
                // Carrega imagem do Firebase
                // const url = await getImageUrl('therapist', id);
                // setPreview(url);
            } catch (err) {
                setError(err);
                showNotification("danger", "Erro ao buscar terapeuta");
            } finally {
                setLoading(false);
            }
        };

        fetchResponsavel();
    }, [showNotification, id]);

    const atualizarResponsavel = async (idusuario) => {
        const payload = {
            ...responsavel,
            id: id,
            userId: idusuario,
        };

        try {
            const response = await authFetch(`therapist`, {
                method: 'PUT',                
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error();

            showNotification('success', 'Dados salvos com sucesso!');
        } catch {
            showNotification('danger', 'Erro ao salvar responsavel');
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Verifica se as senhas coincidem
        if (password !== confirmPassword) {
            alert("As senhas não coincidem!");
            return;
        }

        const userData = {
            username,
            name: responsavel.name,
            userRoleId: Number(userRoleId), // Certificando que é um número
            password
        };

        try {
            const response = await authFetch('user', {
                method: "POST",                
                body: JSON.stringify(userData), // Convertendo o objeto para JSON
            });

            if (!response.ok) {
                throw new Error("Erro ao criar usuário");
            }

            const createdUser = await response.json(); // Aqui você obtém o objeto retornado
            const idusuario = createdUser.id; // Pega o ID do usuário criado

            await atualizarResponsavel(idusuario); // Aguarda a atualização    

            showNotification("success", "Usuário gerado com sucesso!");
            navigate('/');
        } catch (error) {
            console.error("Erro:", error);
            showNotification("danger", "Erro ao gerar usuário");
        }
    };

    if (loading) return <PageLoader />;
    if (error) return <p>Erro: {error}</p>;

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Gerar Usuário Responáveis</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <label htmlFor="nome">Nome</label>
                                    <input type="text" name="name" id="name" className="form-control form-control-sm" value={responsavel.name} readOnly />
                                    <label htmlFor="email">Email</label>
                                    <input type="text" name="username" id="username" className="form-control form-control-sm" onChange={(e) => setUsername(e.target.value)} />
                                    <label htmlFor="senha">Senha</label>
                                    <input type="password" name="password" id="password" className="form-control form-control-sm" onChange={(e) => setPassword(e.target.value)} />
                                    <label htmlFor="confirmarsenha">Confirmar Senha</label>
                                    <input type="password" name="confirmpassword" id="confirmpassword" className="form-control form-control-sm" onChange={(e) => setConfirmPassword(e.target.value)} />
                                    {/* <label htmlFor="foto">Foto</label>
                                    <input type="file" name="foto" id="foto" className="form-control form-control-sm" onChange={(e) => setFoto(e.target.value)} /> */}
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <button type="button" onClick={() => navigate('/')} className="btn btn-info btn-sm">Voltar</button>
                                        <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GerarUsuarioResp